import { FOUNDATION_THEORY, MASTERY_THEORY } from "@/data/theoryGrades";

export const rotate = (arr, k) => arr.slice(k % arr.length).concat(arr.slice(0, k % arr.length));

const termsOf = (sets) => {
  const seen = new Map();
  sets.flat().forEach((s) => (s.terms || []).forEach(([sign, term, meaning]) => { if (!seen.has(term)) seen.set(term, { sign, term, meaning }); }));
  return [...seen.values()];
};
export const BEGINNER_TERMS = termsOf(FOUNDATION_THEORY);
export const ADVANCED_TERMS = termsOf(MASTERY_THEORY);

export const theoryChecks = (course) => course.lessons.filter((l) => l.sections.some((s) => s.theory && s.missing)).map((l) => l.id);

// ~20 questions: one theory check + one term per lesson, in a fixed order so print and screen match.
export function buildPaper(course) {
  const qs = [];
  course.lessons.forEach((l, idx) => {
    const th = l.sections.filter((s) => s.theory);
    const chk = th.flatMap((s) => s.missing || [])[0];
    if (chk) qs.push({ id: `${l.id}c`, prompt: chk.prompt, seq: chk.seq.length > 1 ? chk.seq : null, options: rotate(chk.options, idx + 1), answer: chk.answer });
    const terms = th.flatMap((s) => s.terms || []);
    if (terms.length) {
      const [, term, meaning] = terms[idx % terms.length];
      const wrong = terms.filter((t) => t[2] !== meaning).slice(0, 2).map((t) => t[2]);
      qs.push({ id: `${l.id}t`, prompt: `What does "${term}" mean?`, seq: null, options: rotate([meaning, ...wrong], idx + 2), answer: meaning });
    }
  });
  return qs.slice(0, 20);
}
